'use client'

import React from 'react'
import ScrollContainer from 'react-indiana-drag-scroll'
import styles from './styles.module.css'
import enjoyYourself1 from './_images/enjoy-yourself-1.png'
import enjoyYourself2 from './_images/enjoy-yourself-2.png'
import enjoyYourself3 from './_images/enjoy-yourself-3.png'
import enjoyYourself4 from './_images/enjoy-yourself-4.png'
import enjoyYourself5 from './_images/enjoy-yourself-5.png'
import enjoyYourself6 from './_images/enjoy-yourself-6.png'
import Image from 'next/image'

export default function EnjoyYourself() {
  // todo david - this organization is really bad, refactor when we know what the section will look like better.
  return (
    <section className={styles.sectionWrapper}>
      <div className={styles.innerSectionWrapper}>
        <div className={styles.sectionContents}>
          <h2>You might even enjoy yourself a little</h2>
          <p>Revel in clever shortcuts and extra levels of organization.</p>
        </div>
        <div className={styles.carouselWrapper}>
          <ScrollContainer
            hideScrollbars={false}
            className={styles.carousel}
            draggingClassName={styles.carouselDragging}
          >
            <div className={styles.carouselItem}>
              <Image alt="Search bar" src={enjoyYourself1} />
              <p>Search for nearly anything&nbsp;— from any page. </p>
            </div>
            <div className={styles.carouselItem}>
              <Image alt="Mercury iOS dashboard" src={enjoyYourself2} />
              <p>Accounts are one tap away with native iOS and Android apps.</p>
            </div>
            <div className={styles.carouselItem}>
              <Image alt="Fingerprint" src={enjoyYourself3} />
              <p>Use Touch ID for desktop login. </p>
            </div>
            <div className={styles.carouselItem}>
              <Image alt="Named accounts" src={enjoyYourself4} />
              <p>Create and name accounts for any purpose. </p>
            </div>
            <div className={styles.carouselItem}>
              <Image alt="Named cards" src={enjoyYourself5} />
              <p>Assign card nicknames to segment your spending. </p>
            </div>
            <div className={styles.carouselItem}>
              <Image alt="Date range" src={enjoyYourself6} />
              <p>Plug in dates however you please. </p>
            </div>
          </ScrollContainer>
        </div>
      </div>
    </section>
  )
}
